
    var riot = require('riot')
    //src: starling/src/tags/user-guide.html
riot.tag2('user-guide',
  '<div class="sidebar-content"> <div class="sidebar-header"> <h2>User guide</h2> <div class="search-bar"> <svg class="search-icon"> <use xlink:href="#search-icon"></use> </svg> <input required ref="search" placeholder="Search user guide..." oninput="{this.handleInput}"> <i class="material-icons clear-search-icon" onclick="{this.resetSearch}">close</i> </div> </div> <div ref="sidebarItems" class="sidebar-items dynamic-shadow-scroll" onwheel="{this.handleScroll}"> <h4 if="{this.searchEmpty}" class="section-title">Quick Start Tutorial</h4> <user-guide-item canvas="{parent.canvas}" userguide="{parent}" each="{this.getHelpSectionsByCategory(⁗video⁗)}"></user-guide-item> <h4 if="{this.sectionIsEmpty(\'basic\')}" class="section-title">Basics</h4> <user-guide-item canvas="{parent.canvas}" userguide="{parent}" each="{this.getHelpSectionsByCategory(⁗basic⁗)}"></user-guide-item> <h4 if="{this.sectionIsEmpty(\'workflow\')}" class="section-title">Workflow</h4> <user-guide-item canvas="{parent.canvas}" userguide="{parent}" each="{this.getHelpSectionsByCategory(⁗workflow⁗)}"></user-guide-item> <h4 if="{this.sectionIsEmpty(\'organization\')}" class="section-title">Organization</h4> <user-guide-item canvas="{parent.canvas}" userguide="{parent}" each="{this.getHelpSectionsByCategory(⁗organization⁗)}"></user-guide-item> <h4 if="{this.sectionIsEmpty(\'relationships\')}" class="section-title"> Lines <svg class="section-icon"> <use xlink:href="#userguide-relationship-icon"></use> </svg> </h4> <user-guide-item canvas="{parent.canvas}" userguide="{parent}" each="{this.getHelpSectionsByCategory(⁗relationships⁗)}"></user-guide-item> <h4 if="{this.sectionIsEmpty(\'perspectives\')}" class="section-title"> Perspectives <i class="material-icons section-icon">visibility</i> </h4> <user-guide-item canvas="{parent.canvas}" userguide="{parent}" each="{this.getHelpSectionsByCategory(⁗perspectives⁗)}"></user-guide-item> <h4 if="{this.sectionIsEmpty(\'waypoints\')}" class="section-title"> Slides & Presentation <i class="material-icons section-icon">airplay</i> </h4> <user-guide-item canvas="{parent.canvas}" userguide="{parent}" each="{this.getHelpSectionsByCategory(⁗waypoints⁗)}"></user-guide-item> <h4 if="{this.sectionIsEmpty(\'media\')}" class="section-title"> Media <i class="material-icons section-icon">photo</i> </h4> <user-guide-item canvas="{parent.canvas}" userguide="{parent}" each="{this.getHelpSectionsByCategory(⁗media⁗)}"></user-guide-item> <h4 if="{this.sectionIsEmpty(\'attributes\')}" class="section-title"> Tags <svg class="section-icon"> <use xlink:href="#userguide-attributes-icon"></use> </svg> </h4> <user-guide-item canvas="{parent.canvas}" userguide="{parent}" each="{this.getHelpSectionsByCategory(⁗attributes⁗)}"></user-guide-item> <h4 if="{this.sectionIsEmpty(\'regions\')}" class="section-title"> Regions <svg class="section-icon"> <use xlink:href="#region-icon"></use> </svg> </h4> <user-guide-item canvas="{parent.canvas}" userguide="{parent}" each="{this.getHelpSectionsByCategory(⁗regions⁗)}"></user-guide-item> <h4 if="{this.sectionIsEmpty(\'comments\')}" class="section-title"> Comments <svg class="section-icon"> <use xlink:href="#comment-text-outline-icon"></use> </svg> </h4> <user-guide-item canvas="{parent.canvas}" userguide="{parent}" each="{this.getHelpSectionsByCategory(⁗comments⁗)}"></user-guide-item> <h4 if="{this.sectionIsEmpty(\'privacy\')}" class="section-title"> Privacy and Security </h4> <user-guide-item canvas="{parent.canvas}" userguide="{parent}" each="{this.getHelpSectionsByCategory(⁗privacy⁗)}"></user-guide-item> </div> </div>',
  '',
  '', function(opts) {
'use strict';

var _this = this;

var _searchUi = require('lib/search-ui');

var _userGuide = require('lib/user-guide');

var _constants = require('lib/constants');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canvas = this.opts.canvas;
var isMac = canvas.isMac;

canvas.userGuideTag = this;

this.meta = isMac ? '⌘' : 'ctrl';
this.alt = isMac ? 'option' : 'alt';
this.canvas = canvas;
this.searchEmpty = true;

this.helpData = (0, _userGuide.helpData)({ meta: this.meta, alt: this.alt, config: canvas.config, access: canvas.access, FILE_MAX_SIZE: _constants.FILE_MAX_SIZE, SUBSCRIBER_FILE_MAX_SIZE: _constants.SUBSCRIBER_FILE_MAX_SIZE });

this.filteredHelpData = this.helpData.slice();

this.userGuideItemTags = {};
this.userGuideItemOrder = [];

this.getHelpSectionsByCategory = function (cat) {
  var result = _this.filteredHelpData.filter(function (x) {
    return x.category === cat;
  });

  return result;
};

this.userGuideItemKeys = this.helpData.map(function (item) {
  return item.key;
}).filter(function (key) {
  return key !== undefined;
});

if (window.config.openHelpItem && this.userGuideItemKeys.includes(window.config.openHelpItem)) {
  this.defaultUserGuideItem = window.config.openHelpItem;
} else {
  this.defaultUserGuideItem = 'video';
}

this.handleInput = function (e) {
  if (_this.refs.search.value === '') {
    _this.filteredHelpData = _this.helpData.slice();
    _this.searchEmpty = true;
  } else {
    var initialQuery = _this.refs.search.value.slice();
    var splitQuery = initialQuery.replace(/[^\w\s]|_/g, "").replace(/\s+/g, " ").split(' ');
    var cleanedQuery = splitQuery.filter(function (word) {
      return !_constants.STOP_WORDS.includes(word);
    }).join(' ').trim();

    var _performSearch = function _performSearch(query) {

      var results = _this.helpData.filter(function (helpItem) {
        var searchRegEx = new RegExp('.*' + query + '.*', 'i');
        if (helpItem.title.match(searchRegEx)) {
          return true;
        } else if (helpItem.text.match(searchRegEx)) {
          return true;
        }
        return false;
      });

      if (!results.length && query.length) {
        var newSplitQuery = query.split(' ');
        if (newSplitQuery.length === 1) return [];

        var leftQuery = newSplitQuery.slice(1).join(' ');
        var leftQueryResults = _performSearch(leftQuery);
        var rightQuery = newSplitQuery.slice(0, newSplitQuery.length - 1).join(' ');
        var rightQueryResults = _performSearch(rightQuery);

        if (rightQueryResults.length >= leftQueryResults.length) {
          return rightQueryResults;
        } else {
          return leftQueryResults;
        }
      }

      return results;
    };

    _this.filteredHelpData = _performSearch(cleanedQuery);

    if (_this.filteredHelpData.length) {
      _this.searchEmpty = false;
      _eventTracking2.default.debouncedTrack({
        category: 'User-Guide',
        action: 'User-Guide-Search',
        label: 'User-Guide-Search-With-Results'
      });
    } else {
      _eventTracking2.default.debouncedTrack({
        category: 'User-Guide',
        action: 'User-Guide-Search',
        label: 'User-Guide-Search-Zero-Results'
      });
    }
  }
  _this.update({ forceUpdate: true });
};

this.resetSearch = function () {
  $(_this.refs.search).val('');
  _this.filteredHelpData = _this.helpData.slice();;
  _this.searchEmpty = true;
  _this.update({ forceUpdate: true });
};

this.on('updated', function () {
  if (_this.filteredHelpData.length === 1) {
    if (_this.filteredHelpData[0].category !== 'hidden') {
      if (Array.isArray(_this.tags['user-guide-item'])) {
        _this.tags['user-guide-item'][0].show();
      } else {
        _this.tags['user-guide-item'].show();
      }
    }
  } else if (_this.openUserGuideItem) {
    _this.openUserGuideItem.hide();
  }
});

this.shouldUpdate = function (data, opts) {
  if (data && data.forceUpdate) {
    return true;
  } else {
    return false;
  }
};

this.sectionIsEmpty = function (section) {
  return _this.getHelpSectionsByCategory(section).length > 0;
};

this.handleScroll = function (e) {
  //this is necessary I guess
  e.stopImmediatePropagation();
  e.stopPropagation();
};

this.on('mount', function () {
  _searchUi.searchUI.searchKeyOverride(_this.refs.search);
});

this.openItem = function (userGuideItem) {
  _this.resetSearch();
  var tagToShow = _this.tags['user-guide-item'].reverse().find(function (t) {
    return t.key === userGuideItem;
  });
  if (tagToShow) tagToShow.show();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('user-guide')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/user-guide.html
// module id = 595
// module chunks = 0